module.exports = __webpack_public_path__ + "media/images/categories/headers/internet-and-new-economy-32d2b8e1cccafdb4da5969665e513f9c.jpg";